/**
 * Shared Tailwind class strings for the Site1 template.
 *
 * Site1 has no sibling `.css` files: it styles itself with Tailwind utilities
 * and the `@theme` tokens in `src/index.css`, like the rest of the public site.
 *
 * Per-organization brand colours arrive as the `--site1-*` custom properties
 * that `siteThemeStyle` (theme.js) puts on the template root — always set, and
 * always validated hex — so utilities read them through arbitrary values
 * (`bg-[var(--site1-primary)]`) without a fallback of their own.
 */

/** Centred content column shared by every section. */
export const sheetClass = "mx-auto w-full max-w-[1140px] px-4 sm:px-6";

/**
 * CMS copy is arbitrary: a long unbroken word (a URL, a pasted token) must wrap
 * rather than widen its container and force the page to scroll sideways.
 */
export const cmsTextClass = "[overflow-wrap:anywhere]";

const primaryButtonBase =
  "inline-flex cursor-pointer items-center justify-center gap-2 rounded-xl bg-[var(--site1-primary)] font-semibold text-[var(--site1-on-primary)] transition-colors hover:bg-[var(--site1-primary-hover)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--site1-primary-strong)] motion-reduce:transition-none";

/**
 * The booking button, wherever it appears. Text colour is picked for contrast.
 * Two complete sizes rather than one size plus overrides: an appended `px-7`
 * ties with the constant's `px-5` and the stylesheet's order picks the winner.
 */
export const primaryButtonClass = `${primaryButtonBase} min-h-11 px-5 py-2.5 text-sm`;

export const primaryButtonLargeClass = `${primaryButtonBase} min-h-12 px-7 py-3 text-base shadow-card`;

/** Small uppercase label over a block: CONTACT, PROGRAM. */
export const eyebrowClass =
  "m-0 text-xs font-bold uppercase tracking-[0.14em] text-ink-500";

/** Round icon tile in the brand's tint. */
export const iconTileClass =
  "flex size-9 shrink-0 items-center justify-center rounded-full bg-[var(--site1-primary-muted)] text-[var(--site1-primary-strong)]";
